import {Gift }from '../gift/gift'; 

export class GiftSelection {
 gift:Gift; 
 price:number; 
scrollY:number; 
isEditing:boolean; 
guestServiceFee:number;
coupleServiceFee:number;

public GuestPrice():number {
    return this.price +( this.guestServiceFee/100*this.price);

}

}




// WEBPACK FOOTER //
// ./src/app/gift/giftSelection.ts